import { connect } from 'react-redux';

import ListComponent from './ListComponent';

const getSubtext = p => {
  const numPrices = p.prices.reduce(
    (sum, r) => sum + ((r.result && r.result.length) || 0),
    0,
  );
  const pricesText = numPrices
    ? `, ${numPrices} ${numPrices === 1 ? 'pris' : 'priser'}`
    : '';
  const memberText = p.member_from
    ? `${p.member_from} - ${p.member_to ? p.member_to : '?'}`
    : '';
  return `${memberText}${pricesText}`;
};

const mapStateToProps = ({ photographers }, _) => {
  return {
    title: 'Fotografer i lauget',
    data: photographers.data
      .sort((a, b) => (a.member_from < b.member_from ? 1 : -1))
      .map(p => ({
        id: p.id,
        leftIcon: 'fa fa-user-o pr1',
        title: p.name || `${p.first_name} ${p.last_name}`,
        url: `/fotografer/${p.id}`,
        subtext: getSubtext(p),
        // TODO: Add icon for gold, silver, bronze, oldermann
      })),
  };
};

export default connect(mapStateToProps)(ListComponent);



// WEBPACK FOOTER //
// ./src/pages/PhotographerList.js